import logoImage from "../assets/crescent-logo.png";

export const imagepathReturn = (imageUrl: string) => {
  if (imageUrl) {
    return process.env.REACT_APP_BACKEND_URL + imageUrl;
  }
  return logoImage;
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    // hour: "2-digit",
    // minute: "2-digit",
  });
};
